import React from 'react';
import { Equipment } from '../../../../model/equipment';
import { EquipmentModel } from '../../../../model/equipment-model';
import { entityManagerProvider } from '../../../../model/entity-manager-provider';
import { EntityManager, EntityQuery } from 'breeze-client';
import moment from 'moment';
import { Card } from 'react-bootstrap';
import { Loader } from '@progress/kendo-react-indicators';
import { Category } from '../../../../model/category';
import { Brand } from '../../../../model/brand';
import { Country } from '../../../../model/country';
import { Supplier } from '../../../../model/supplier';
import { Customer } from '../../../../model/customer';
import { EquipmentStatus } from '../../../../model/equipment-status';
interface EquipmentList {
  equipment: Equipment;
  ids: number;
  loading: boolean;
  allowAdd: boolean;
  categories: Category[];
  brands: Brand[];
  models: EquipmentModel[];
  countries: Country[];
  customers: Customer[];
  suppliers: Supplier[];
  statuses: EquipmentStatus[];
}

class Equipments extends React.Component<any, EquipmentList> {
  manager: EntityManager;
  constructor(props) {
    super(props);
    this.state = {
      equipment: null as Equipment,
      ids: 0 as number,
      loading: true,
      allowAdd: true,
      brands: [] as Brand[],
      categories: [] as Category[],
      models: [] as EquipmentModel[],
      customers: [] as Customer[],
      suppliers: [] as Supplier[],
      countries: [] as Country[],
      statuses: [] as EquipmentStatus[],
    };
    this.manager = entityManagerProvider.newManager();

    this.saveChanges = this.saveChanges.bind(this);
    this.rejectChanges = this.rejectChanges.bind(this);
    this.setTypeState = this.setTypeState.bind(this);
  }

  componentDidMount() {
    entityManagerProvider.subscribeComponent(this.manager, this);

    const query = new EntityQuery('Equipments')
      .expand('brand, country, equipmentModel')
      .where('equipmentId', 'equals', this.props.currentProductId);
    const queryBrand = new EntityQuery('Brands');
    const queryCategories = new EntityQuery('Categories');
    const queryModels = new EntityQuery('EquipmentModels');
    const queryCustomer = new EntityQuery('Customers');
    const querySupplier = new EntityQuery('Suppliers');
    const queryCountry = new EntityQuery('Countries');
    const queryStatus = new EntityQuery('EquipmentStatuses');

    this.manager.executeQuery(query).then((qr) => {
      this.setState({
        equipment: qr.results[0],
      });
      this.manager.executeQuery(queryCategories).then((qr) => {
        this.setState({
          categories: qr.results,
        });
        this.manager.executeQuery(queryBrand).then((qr) => {
          this.setState({
            brands: qr.results,
          });
        });
        this.manager.executeQuery(queryModels).then((qr) => {
          this.setState({
            models: qr.results,
          });
        });
        this.manager.executeQuery(queryCustomer).then((qr) => {
          this.setState({
            customers: qr.results,
          });
        });
        this.manager.executeQuery(querySupplier).then((qr) => {
          this.setState({
            suppliers: qr.results,
          });
        });
        this.manager.executeQuery(queryCountry).then((qr) => {
          this.setState({
            countries: qr.results,
          });
        });
        this.manager.executeQuery(queryStatus).then((qr) => {
          this.setState({
            statuses: qr.results,
            loading: false,
          });
        });
      });
    });
  }
  componentWillUnmount() {
    entityManagerProvider.unsubscribeComponent(this.manager, this);
  }

  remove(ent: Equipment) {
    ent.entityAspect.setDeleted();
    this.saveChanges();
  }
  dateFormatter(cell) {
    if (!cell) {
      return '';
    }
    return `${
      moment(cell).format('DD-MM-YYYY')
        ? moment(cell).format('DD-MM-YYYY')
        : moment(cell).format('DD-MM-YYYY')
    }`;
  }

  isPaidString(isPaid) {
    if (isPaid) {
      return 'Paid';
    }
    return 'Not Paid';
  }
  saveChanges() {
    this.setState({
      loading: true,
    });
    this.manager
      .saveChanges()
      .then(() => {
        // refresh customer list to remove deleted customers
        this.setState({
          loading: false,
          equipment: this.manager.getEntityByKey(
            'Equipment',
            this.props.currentProductId
          ) as Equipment,
        });
      })
      .catch((error) => {
        console.log('error catch', error, error.entityErrors);
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  rejectChanges() {
    this.manager.rejectChanges();
    // refresh customer list to restore original state
  }

  renderPaymentEdit() {
    let equipment = this.state.equipment;
    function handleCatChange(event) {
      equipment.categoryId = event.target.value;
    }
    function handleBrandChange(event) {
      equipment.brandId = event.target.value;
      equipment.equipmentModelId = null;
    }
    function handleModelChange(event) {
      equipment.equipmentModelId = event.target.value;
    }
    function handleCountryChange(event) {
      equipment.countryId = event.target.value;
    }
    function handleCustChange(event) {
      equipment.customerId = event.target.value;
    }
    function handleSupplierChange(event) {
      equipment.supplierId = event.target.value;
    }
    function handleStatusChange(event) {
      equipment.equipmentStatusId = event.target.value;
    }
    if (equipment) {
      return (
        <div>
          <Card border="primary" style={{ width: '100%' }}>
            <Card.Header>
              <div>Details</div>
            </Card.Header>
            <Card.Body>
              <form className="form form-label-right">
                <div className="form-group row">
                  <div className="col-lg-3">
                    <label>Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="eqiupmentName"
                      value={equipment.eqiupmentName || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Make</label>
                    <input
                      className="form-control"
                      type="number"
                      name="yearMake"
                      value={equipment.yearMake || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Hours</label>
                    <input
                      className="form-control"
                      type="number"
                      name="workingHours"
                      value={equipment.workingHours || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label>Weight</label>
                    <input
                      className="form-control"
                      type="number"
                      name="weight"
                      value={equipment.weight || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>Purchase Price (EGP)</label>
                    <input
                      className="form-control"
                      type="number"
                      name="purchasingPrice"
                      value={equipment.purchasingPrice || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>exChange Rate</label>
                    <input
                      className="form-control"
                      type="number"
                      name="exchangeRate"
                      value={equipment.exchangeRate || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                  <div className="col-lg-4">
                    <label>Selling Price (EGP)</label>
                    <input
                      className="form-control"
                      type="number"
                      name="salesPrice"
                      value={equipment.salesPrice || ''}
                      onChange={equipment.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <label>Category</label>
                    <select
                      className="form-control"
                      name="categoryId"
                      onChange={handleCatChange}
                      value={equipment.categoryId}
                    >
                      {this.state.categories?.map((cat) => {
                        return (
                          <option key={cat.categoryId} value={cat.categoryId}>
                            {cat.categoryName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <label>Manufacturer</label>
                    <select
                      className="form-control"
                      name="brandId"
                      onChange={handleBrandChange}
                      value={equipment.brandId}
                    >
                      {this.state.brands?.map((brand) => {
                        return (
                          <option key={brand.brandId} value={brand.brandId}>
                            {brand.brandName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-4">
                    <label>Model</label>
                    <select
                      className="form-control"
                      name="brandId"
                      onChange={handleModelChange}
                      value={equipment.equipmentModelId}
                    >
                      {this.state.equipment &&
                        !this.state.equipment.equipmentModelId && (
                          <option key={null}>Select Model</option>
                        )}
                      {this.state.models
                        ?.filter(
                          (m) => m.brandId === this.state.equipment.brandId
                        )
                        .map((model) => {
                          return (
                            <option
                              key={model.equipmentModelId}
                              value={model.equipmentModelId}
                            >
                              {model.modelName}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-3">
                    <label>Status</label>
                    <select
                      className="form-control"
                      name="equipmentStatusId"
                      onChange={handleStatusChange}
                      value={equipment.equipmentStatusId}
                    >
                      {this.state.statuses?.map((status) => {
                        return (
                          <option
                            key={status.equipmentStatusId}
                            value={status.equipmentStatusId}
                          >
                            {status.statusName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label>Customer</label>
                    <select
                      className="form-control"
                      name="customerId"
                      onChange={handleCustChange}
                      value={equipment.customerId}
                    >
                      {this.state.customers?.map((cust) => {
                        return (
                          <option key={cust.customerId} value={cust.customerId}>
                            {cust.customerName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label>Supplier</label>
                    <select
                      className="form-control"
                      name="supplierId"
                      onChange={handleSupplierChange}
                      value={equipment.supplierId}
                    >
                      {this.state.suppliers?.map((supplier) => {
                        return (
                          <option
                            key={supplier.supplierId}
                            value={supplier.supplierId}
                          >
                            {supplier.supplierName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <label>Country</label>
                    <select
                      className="form-control"
                      name="countryId"
                      onChange={handleCountryChange}
                      value={equipment.countryId}
                    >
                      {this.state.countries?.map((country) => {
                        return (
                          <option
                            key={country.countryId}
                            value={country.countryId}
                          >
                            {country.countryName}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    name="description"
                    value={equipment.description || ''}
                    onChange={equipment.handleChangeArea}
                  />
                </div>
              </form>
            </Card.Body>
          </Card>
        </div>
      );
    }
  }

  setTypeState(type: Equipment) {
    this.rejectChanges();
  }
  render() {
    return (
      <div className="card card-custom card-stretch">
        <div className="card-header py-3">
          <div className="card-title align-items-start flex-column">
            <h3 className="card-label font-weight-bolder text-dark">
              Name: {this.state.equipment?.eqiupmentName}
            </h3>
            <span className="text-muted font-weight-bold font-size-sm mt-1">
              Brand : {this.state.equipment?.brand.brandName}
            </span>
          </div>
          <div className="card-toolbar">
            <button
              type="submit"
              className="btn btn-success mr-2"
              onClick={this.saveChanges}
              disabled={
                !this.state.equipment?.equipmentModelId ||
                !this.manager.hasChanges()
              }
            >
              Save
            </button>
            <button
              type="submit"
              className="btn btn-warning mr-2"
              onClick={() => {
                this.rejectChanges();
              }}
            >
              Cancel
            </button>
          </div>
        </div>
        <div className="card-body">
          {this.state.loading ? (
            <div className="row" style={{ minHeight: '200px' }}>
              <Loader
                size="large"
                style={{ position: 'relative', margin: '60px auto' }}
                type="converging-spinner"
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-xl-12">{this.renderPaymentEdit()}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Equipments;
